export const INVALID_EMAIL_WARNING = "INVALID_EMAIL_WARNING";
export const EMAIL_VALIDATED_STORAGE_KEY = "ot-checkout-email-validated";
